@if (consent(); as c) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
          <i class="pi pi-verified text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Aceptación</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-medium text-slate-500">Tipo</p>
            <p class="text-sm font-semibold text-slate-900">{{ typeLabel() }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de aceptación</p>
            <p class="text-sm text-slate-700">{{ c.acceptedAt ? (c.acceptedAt | date:'dd/MM/yyyy HH:mm:ss') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Firma electrónica</p>
            <p class="text-sm text-slate-700">{{ c.signerName || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Correo del cliente</p>
            @if (c.customerEmail) {
              <a [href]="'mailto:' + c.customerEmail" class="text-sm text-sky-600 hover:text-sky-800">{{ c.customerEmail }}</a>
            } @else {
              <p class="text-sm text-slate-700">—</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Versión de términos</p>
            <p class="text-sm text-slate-700">{{ c.termsVersion || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Cargo de registro</p>
            @if (c.transactionId && canReadTransactions) {
              <a [routerLink]="['/mit-transactions', c.transactionId]" class="inline-flex items-center gap-1 text-sm text-sky-600 hover:text-sky-800">
                Ver transacción <i class="pi pi-external-link text-[10px]"></i>
              </a>
            } @else {
              <p class="text-sm text-slate-700">{{ c.transactionId ? 'Registrado' : '—' }}</p>
            }
          </div>
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Huella del documento (SHA-256)</p>
            <p class="text-xs text-slate-700 font-mono break-all flex items-start gap-1.5">
              <span>{{ c.termsTextSha256 || '—' }}</span>
              @if (c.termsTextSha256) {
                <button
                  type="button"
                  class="text-slate-400 hover:text-sky-600 transition shrink-0"
                  (click)="copy(c.termsTextSha256, 'Hash')"
                  pTooltip="Copiar hash"
                  tooltipPosition="top"
                  aria-label="Copiar hash">
                  <i class="pi pi-copy text-xs"></i>
                </button>
              }
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
          <i class="pi pi-sliders-h text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Límites aceptados</span>
      </div>
      <div class="px-4 py-2.5 border-b border-slate-100">
        <p class="text-xs font-medium text-slate-500">Vigencia</p>
        <p class="text-sm text-slate-700">
          {{ c.validFrom ? (c.validFrom | date:'dd/MM/yyyy HH:mm') : 'Desde su activación' }}
          — {{ c.validUntil ? (c.validUntil | date:'dd/MM/yyyy HH:mm') : 'sin fin' }}
        </p>
      </div>
      @if (c.limits) {
        <div class="divide-y divide-slate-100">
          @for (row of limitRows; track row.key) {
            <div class="flex items-center justify-between gap-3 px-4 py-2">
              <span class="text-xs text-slate-600">{{ row.label }}</span>
              <span class="text-xs font-semibold text-slate-900 tabular-nums whitespace-nowrap">{{ limitValue(row) }}</span>
            </div>
          }
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin límites registrados.</p>
      }
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
          <i class="pi pi-credit-card text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Tarjeta</span>
      </div>
      @if (c.cardLastDigits) {
        <div class="p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-medium text-slate-500">Tarjeta</p>
            <p class="text-sm text-slate-700">{{ c.cardBrand || 'Tarjeta' }} <span class="font-mono">•••• {{ c.cardLastDigits }}</span></p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Vencimiento</p>
            <p class="text-sm text-slate-700">
              {{ c.cardExpirationMonth && c.cardExpirationYear ? c.cardExpirationMonth + '/' + c.cardExpirationYear : '—' }}
            </p>
          </div>
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin tarjeta asociada al consentimiento.</p>
      }
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-amber-100 text-amber-600">
          <i class="pi pi-desktop text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Evidencia del dispositivo</span>
      </div>
      <div class="p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
        <div>
          <p class="text-xs font-medium text-slate-500">IP</p>
          <p class="text-sm text-slate-700 font-mono">{{ c.ipAddress || '—' }}</p>
        </div>
        <div>
          <p class="text-xs font-medium text-slate-500">Idioma del navegador</p>
          <p class="text-sm text-slate-700">{{ c.acceptLanguage || '—' }}</p>
        </div>
        <div class="sm:col-span-2">
          <p class="text-xs font-medium text-slate-500">Navegador (user agent)</p>
          <p class="text-xs text-slate-700 font-mono break-all">{{ c.userAgent || '—' }}</p>
        </div>
        <div class="sm:col-span-2">
          <p class="text-xs font-medium text-slate-500">Huella del dispositivo (SHA-256)</p>
          <p class="text-xs text-slate-700 font-mono break-all">{{ c.deviceFingerprint || '—' }}</p>
        </div>
      </div>
      @if (deviceRows().length) {
        <div class="divide-y divide-slate-100 border-t border-slate-100">
          @for (row of deviceRows(); track row.key) {
            <div class="flex items-start justify-between gap-3 px-4 py-1.5">
              <span class="text-[11px] font-medium text-slate-500 shrink-0">{{ row.key }}</span>
              <span class="text-[11px] text-slate-700 font-mono text-right break-all">{{ row.value }}</span>
            </div>
          }
        </div>
      }
    </div>

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center justify-between gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <div class="flex items-center gap-2">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
            <i class="pi pi-file text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Términos aceptados</span>
        </div>
        @if (c.termsText) {
          <button
            type="button"
            class="inline-flex items-center gap-1 text-xs font-medium text-sky-700 hover:text-sky-900"
            (click)="copy(c.termsText, 'Texto')">
            <i class="pi pi-copy text-[10px]"></i> Copiar texto
          </button>
        }
      </div>
      @if (c.termsText) {
        <div class="p-4 max-h-[28rem] overflow-y-auto">
          <p class="text-xs text-slate-700 leading-relaxed whitespace-pre-wrap break-words m-0">{{ c.termsText }}</p>
        </div>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin texto registrado.</p>
      }
    </div>
  </div>
}
